import {SuittService} from '../services/index';
import {setUserInfoToLocalStorage} from '../utils/index';
import {makeAutoObservable} from 'mobx';

class Auth {
    user = null;
    errors = [];
    suittService = new SuittService();

    constructor() {
        makeAutoObservable(this);
    }

    async doLogin(loginForm) {
        const result = await this.suittService.doLogin(loginForm);
        const userData = result.data;
        if (userData) {
            this.user = userData;
            this.errors = [];
            setUserInfoToLocalStorage(userData);
        } else {
            const errs = Array.isArray(result.errors) ? result.errors : [];
            this.errors = errs.map(e => {
                const code = e?.code ?? e?.errorCode;
                if (code === 404000) {
                    return { ...e, message: "Користувача з такою поштою не знайдено" };
                }
                return e;
            });
        }
    }

    setUser(user){
        this.user = user;
    }

    clearAll(){
        this.user = null;
        this.errors = [];
    }
}

const authInstance = new Auth();
export default authInstance;
